<template>
    <div>
        <h3>Paramètres > Pays</h3>
        <br />

        <v-snackbar
            v-model="snackbar"
            :timeout="snackbar_timeout"
            :color="snackbar_color"
            :top="true"
        >
            {{ snackbar_message }}
        </v-snackbar>

        <v-card flat class="mt-5">
            <v-card-title>
                <h6 class="primary--text">Liste des pays</h6>
                <v-spacer></v-spacer>

                <v-btn
                    rounded
                    color="primary"
                    class="text-capitalize"
                    v-if="$can('export countries')"
                >
                    <export-excel
                        :data="countries"
                        name="Pays.xls"
                        :export-fields="pays_fields"
                    >
                        Exporter
                        <v-icon right>mdi-share-outline</v-icon>
                    </export-excel>
                </v-btn>
                <v-spacer></v-spacer>

                <v-dialog v-model="dialog_edit" max-width="500px">
                    <template v-slot:activator="{ on }">
                        <v-btn
                            rounded
                            color="primary"
                            dark
                            class="mb-2"
                            v-on="on"
                            v-if="$can('create countries')"
                        >
                            Ajouter
                            <v-icon right>mdi-plus-circle-outline</v-icon>
                        </v-btn>
                    </template>
                    <v-card>
                        <v-card-title>
                            <span class="headline">{{ formTitle }}</span>
                        </v-card-title>

                        <v-card-text>
                            <v-container grid-list-md>
                                <v-layout wrap>
                                    <v-flex xs12 sm6 md4>
                                        <v-text-field
                                            v-model="editedItem.name"
                                            label="Nom du pays"
                                            solo
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12 sm6 md4>
                                        <v-text-field
                                            v-model="
                                                editedItem.country_calling_code
                                            "
                                            label="Indicatif"
                                            solo
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12 sm6 md4>
                                        <v-text-field
                                            v-model="editedItem.code"
                                            label="Code"
                                            solo
                                        ></v-text-field>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-card-text>

                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn
                                color="info"
                                rounded
                                @click="dialog_edit = false"
                                >Fermer</v-btn
                            >
                            <v-btn color="primary" rounded @click="save"
                                >Enregistrer</v-btn
                            >
                        </v-card-actions>
                    </v-card>
                </v-dialog>

                <v-spacer></v-spacer>

                <v-text-field
                    v-model="search"
                    @input="fetchUtils()"
                    append-icon="mdi-magnify"
                    label="Rechercher un pays"
                    single-line
                    solo
                    hide-details
                >
                </v-text-field>
            </v-card-title>
        </v-card>

        <v-data-table
            v-if="countries"
            :headers="headers"
            :items="countries"
            :loading="loading"
            loading-text="Loading..."
            sort-by="name"
            :search="search"
            :page.sync="currentPage"
            :server-items-length="countryTotalItems"
            :items-per-page.sync="rowsPerPageItems"
            :footer-props="footerProps"
            class="elevation-1 mr-10"
        >
            <template v-slot:item.action="{ item }">
                <v-icon
                    small
                    class="mr-2"
                    @click="editItem(item)"
                    v-if="$can('edit countries')"
                >
                    mdi-pencil-outline
                </v-icon>
                <v-icon
                    small
                    @click="deleteItem(item)"
                    v-if="$can('delete countries')"
                >
                    mdi-trash-can-outline
                </v-icon>
            </template>
        </v-data-table>

        <v-layout row justify-center>
            <v-dialog v-model="dialog_deletion" max-width="290">
                <v-card>
                    <v-card-title class="headline">Suppression</v-card-title>
                    <v-card-text class="text-center">
                        Etes-vous sûr de vouloir supprimer ce pays ?
                    </v-card-text>

                    <v-card-actions>
                        <v-btn
                            color="orange"
                            rounded
                            @click="dialog_deletion = false"
                        >
                            <span class="white-couleur">Non</span>
                        </v-btn>
                        <v-spacer></v-spacer>
                        <v-btn
                            color="success"
                            :loading="load"
                            :disabled="load"
                            rounded
                            @click="delCountry()"
                        >
                            Oui
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-layout>
    </div>
</template>

<script>
import axios from "axios";
import Permissions from "~/mixins/Permissions";

export default {
    name: "settings-country",
    mixins: [Permissions],
    data: () => ({
        del_country: null,
        search: null,
        loading: false,
        load: false,
        dialog_edit: false,
        dialog_deletion: false,
        headers: [
            { text: "Nom", value: "name" },
            { text: "Indicatif", value: "country_calling_code" },
            { text: "Code", value: "code" },
            { text: "Actions", value: "action", sortable: false }
        ],
        pays_fields: {
            Nom: "name",
            Indicatif: "country_calling_code",
            Code: "code"
        },
        snackbar: false,
        snackbar_message: "",
        snackbar_timeout: 5000,
        snackbar_color: "",

        editedIndex: -1,
        editedItem: {
            name: "",
            country_calling_code: "+",
            code: ""
        },
        defaultItem: {
            name: "",
            country_calling_code: "+",
            code: ""
        },
        payload: {
          query: {
                page: 1,
                size: 15
            }
        },
        footerProps: {
            "items-per-page-options": [5, 10, 15, 30, 50, 100, 500],
            "items-per-page-text": "Lignes par page"
        },
        uri: '/countries',
        countries: [],
        currentPage: 1,
        pagination: {
            current: 1,
            total: 0,
            rowsPerPage: 15
        },
        rowsPerPageItems: 15,
        countryTotalItems: 0
    }),

    created() {
      this.fetchUtils();
    },

    computed: {
        formTitle() {
            return this.editedIndex === -1 ? "Nouveau pays" : "Editer le pays";
        }
    },

    watch: {
        dialog(val) {
            val || this.close();
        },

        rowsPerPageItems(newVal, oldVal) {
            if (newVal != oldVal) {
                this.pagination.rowsPerPage = newVal;
                this.fetchUtils();
            }
        },
        currentPage(newVal, oldVal) {
            if (newVal != oldVal) {
                this.pagination.current = newVal;
                this.fetchUtils();
            }
        }
    },

    methods: {
        async fetchUtils() {
            this.loading = true;
            let newUri =
                this.uri +
                "?page=" +
                this.pagination.current +
                "&size=" +
                this.pagination.rowsPerPage;

            if (this.search) {
                newUri = newUri + "&search=" + this.search;
            }            
            const results = (await axios.get(newUri)).data;

            if (results.data) {
                this.countries = results.data;
                this.currentPage = results.current_page;
                this.countryTotalItems = results.total;

                this.rowsPerPageItems = parseInt(results.per_page);
                this.pagination.last_page = results.last_page;
            }

            this.loading = false;
        },
        editItem(item) {
            this.editedIndex = this.countries.indexOf(item);
            this.editedItem = Object.assign({}, item);
            this.dialog_edit = true;
        },

        deleteItem(item) {
            const index = this.countries.indexOf(item);
            // confirm('Are you sure you want to delete this item?') && this.pays.splice(index, 1)

            this.dialog_deletion = true;
            this.del_country = item;
        },

        close() {
            this.dialog_edit = false;
            setTimeout(() => {
                this.editedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1;
            }, 300);
        },

        async save() {
            this.load = true;
            if (this.editedIndex > -1) {
                await this.$store.dispatch("updateCountry", this.editedItem);
                this.snackbar = true;
                this.snackbar_color = "success";
                this.snackbar_message = "Pays édité avec succès !";
            } else {
                await this.$store.dispatch("createCountry", this.editedItem);
                this.snackbar = true;
                this.snackbar_color = "success";
                this.snackbar_message = "Pays enregistré avec succès !";
            }
            this.close();
            this.load = false;
            this.fetchUtils();
        },

        async delCountry(index) {
            this.load = true;
            await this.$store.dispatch("deleteCountry", this.del_country);
            this.fetchUtils();
            this.dialog_deletion = false;
            this.snackbar = true;
            this.snackbar_color = "success";
            this.snackbar_message = "Pays supprimé avec succès !";
            this.load = false;
        }
    }
};
</script>

<style scoped>
.white-couleur {
    color: white;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/settings/country.vue